export default {"src":"/_next/static/media/right-arrow.af2d6b84.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};